<template>
    <div class="row m-1 mt-2">
       
        <div class="col-md-12">
            <div class="card">
                <div class="card-body">
                    <div class="container [ pt-5 pb-4 ] [ text-center ]">
                        <h1 class="heading text-primary text-center">
                            <span class="d-block"><font-awesome-icon :icon="['far','check-circle']" size="4x" :class="d-block"></font-awesome-icon></span>
                            Grazie, la segnalazione è stata inoltrata con successo
                        </h1>
                       

                    </div>

                    <div>
                       
                    
                        <h3>Erede</h3>
                        <hr>
                        <div class="row">
                            <div class="col">
                                <div class="form-group">
                                    <label class="col-form-label" for="name">Nome</label>
                                    <p>{{inheritance.name}}</p>
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label class="col-form-label" for="lastname">Cognome</label>
                                    <p>
                                        {{inheritance.surname}}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="form-group">
                                    <label class="col-form-label" for="username">Telefono</label>
                                     <p>{{inheritance.phone}}
                                    </p>
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label class="col-form-label" for="email">Email</label>
                                    <p>{{inheritance.email}}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <h3>Defunto</h3>
                        <hr>
                        <div class="row">
                            <div class="col">
                                <div class="form-group">
                                    <label class="col-form-label" for="name">Nome</label>
                                     <p>{{inheritance.deceaseName}}
                                    </p>
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label class="col-form-label" for="lastname">Cognome</label>
                                   <p>{{inheritance.deceaseSurname}}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <!--<h3>Filiale</h3>
    <hr>-->
                        <div class="row d-none">
                            <div class="col">
                                <div class="form-group">
                                    <label class="col-form-label" for="name">Identificativo</label>
                                    <p>{{inheritance.externalCode}}
                                    </p>
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label class="col-form-label" for="lastname">Gestore</label>
                                     <p>{{inheritance.operator}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="container">
                        <div class="text-center [ pt-4 pb-5 ]">
                            <router-link class="btn btn-sm btn-primary" :to="{name:'route-create-inheritance'}">
                                <font-awesome-icon icon="plus-circle"></font-awesome-icon> Aggiungi nuova segnalazione
                            </router-link>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
</template>
<script>
export default {
        name: "Success",
         computed: {
            inheritance: function () {
                return this.$store.state.inheritance;
            }
        }
};
</script>

